import { render } from "./UserCart.vue?vue&type=template&id=dee8767a&scoped=true"
import script from "./UserCart.vue?vue&type=script&lang=js"
export * from "./UserCart.vue?vue&type=script&lang=js"

import "./UserCart.vue?vue&type=style&index=0&id=dee8767a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee8767a"]])

export default __exports__